// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, createRef, useRef } from 'react';
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/standard-button';
import MediaServicesFitToPageIcon from '@atlaskit/icon/core/migration/shrink-diagonal--media-services-fit-to-page';
import { HeaderWrapper, DismissButtonWrapper } from './styled';
import { token } from '@atlaskit/tokens';
export interface ChecklistHeaderProps {
	header?: React.ReactNode;
	onClose: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	shouldFocus?: boolean;
}

export default ({ header, onClose, shouldFocus }: ChecklistHeaderProps): React.JSX.Element => {
	const minimisedButton = createRef<HTMLButtonElement>();
	const havebeenFocused = useRef<boolean>(false);
	useEffect(() => {
		if (shouldFocus && !havebeenFocused.current && minimisedButton?.current) {
			minimisedButton.current.focus();
			havebeenFocused.current = true;
		}
	}, [shouldFocus, minimisedButton]);

	return (
		<HeaderWrapper>
			<div>{header && header}</div>
			<DismissButtonWrapper>
				<Button
					testId="checklist-header-dismiss-link"
					onClick={onClose}
					iconBefore={
						<MediaServicesFitToPageIcon
							label="minimize"
							color={token('color.icon.inverse', colors.N0)}
							spacing="spacious"
						/>
					}
					ref={minimisedButton}
				/>
			</DismissButtonWrapper>
		</HeaderWrapper>
	);
};
